import { render, staticRenderFns } from "./SelecioneUF.vue?vue&type=template&id=5994a56c&scoped=true&"
import script from "./SelecioneUF.vue?vue&type=script&lang=js&"
export * from "./SelecioneUF.vue?vue&type=script&lang=js&"
import style0 from "./SelecioneUF.vue?vue&type=style&index=0&id=5994a56c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5994a56c",
  null
  
)

export default component.exports